import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type DNAModalProps = {
  isVisible: DNAModalState['isVisible'],
  setModal: (a: DNASetModalArgs) => void,
  closeModal: () => void,
  toggleModal: () => void,
  pushModal: (c: DNAModalComponent) => void,
}

export type DNAModalComponent = (p: DNAModalProps) => React.ReactElement

export type DNAModalState = {
  isVisible: boolean,
  allowBackdropCancel: boolean,
  // [TODO] Consider supporting Modal stacks
  component: DNAModalComponent[],
}

export type DNASetModalArgs = Pick<
  DNAModalState,
  'isVisible' |
  'allowBackdropCancel'
> & {
  component: DNAModalComponent | DNAModalComponent[]
}

const initialState: DNAModalState = {
  isVisible: false,
  allowBackdropCancel: false,
  component: [],
}

const DNAModalSlice = createSlice({
  name: 'DNAModalSlice',
  initialState: initialState,
  reducers: {
    setModal: (
      state,
      { payload }: PayloadAction<DNASetModalArgs>) => {
      const { component, ...restPayload } = payload

      return {
        ...state,
        ...restPayload,
        component: Array.isArray(component) ? component : [component],
      }
    },
    pushModal: (
      state,
      { payload }: PayloadAction<DNAModalComponent>,
    ) => {
      if (state.component) {
        state.component.push(payload)
      }
      else {
        state.component = [payload]
      }
    },
    closeModal: (state) => {
      state.isVisible = false
      state.component = []
    },
    toggleModal: (state) => {
      state.component.pop()

      if (!state.component.length) {
        state.isVisible = false
      }
    },
  },
})

export default DNAModalSlice;
export const DNAModalActions = DNAModalSlice.actions
